"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const shortDelayInMs = 1000;
const longDelayInMs = 3000;
const Spinner = ({ size = 'sm', delay = 'short', color = 'purple' }) => {
    const [isInvisible, setIsInvisible] = react_1.useState(true);
    const spinnerClasses = classnames_1.default({
        'invisible': isInvisible,
        'loading-spinner': true,
        [`loading-spinner--${color}`]: !!color,
        [`loading-spinner--${size}`]: !!size,
    });
    const delayInMs = getDelayInMs();
    react_1.useEffect(() => {
        const timer = setTimeout(() => setIsInvisible(false), delayInMs);
        return () => clearTimeout(timer);
    }, []);
    return React.createElement("div", { className: spinnerClasses });
    function getDelayInMs() {
        switch (delay) {
            case 'short':
                return shortDelayInMs;
            case 'long':
                return longDelayInMs;
            default:
                return 0;
        }
    }
};
exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map